import { render, staticRenderFns } from "./Anynews.vue?vue&type=template&id=bbde5ffc"
import script from "./Anynews.vue?vue&type=script&lang=js"
export * from "./Anynews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports